var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('UIBox',{class:'asb-competitor'},[_c('UIText',[_vm._v(_vm._s(_vm.competitor.Name))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }